/** basic.alarmRecirds */
export default {
    backAlarmRecords: "Назад к записям тревог устройства",
    selectAlarmPla: "Выберите причину тревоги",
    pushState: "Состояние push",
    dialogTitle: "Обработка тревоги",
    alarmCausePla: "Выберите причину тревоги",
    AllAlarmCause: "Все причины тревоги",
    pushRecords: "Записи push",
    isCollectTips: "Отменить избранное для этого устройства?",
    cancelCollect: "Убрать из избранного",
    message_cancelCollectSucc: "Убрано из избранного!",
    message_cancelCollectLose: "Не удалось убрать из избранного!",
}

